// header-menus

// MEGA MENU DESKTOP FUNCTIONALITY
document.addEventListener("DOMContentLoaded", function () {
	initMegaMenu();
	setupEventListeners();

	const firstNonStandardOption = document.querySelector(
		".mega-menu-option:not(.standard-option):not(.mobile)",
	);
	if (firstNonStandardOption) {
		firstNonStandardOption.classList.add("show-chevron");
	}
});

function initMegaMenu() {
	const liContainers = document.querySelectorAll(
		".li-container.mega-menu-container.mega-menu-wrapper",
	);
	liContainers.forEach((liContainer) => {
		const firstStandard = liContainer.querySelector(".standard-option.desktop");

		if (firstStandard) {
			firstStandard.style.borderTop = "1px #1a1a1e solid";
			firstStandard.style.paddingTop = "40px";
			firstStandard.style.marginTop = "20px";
		}
		const menuOptions = liContainer.querySelectorAll(
			".mega-menu-option:not(.mobile)",
		);
		const menuContents = liContainer.querySelectorAll(
			".mega-menu-right-content",
		);
		let firstHover = true;
		let lastVisibleContent = null;
		let hoverTimeout;

		menuOptions.forEach((option) => {
			option.addEventListener("mouseover", (event) => {
				clearTimeout(hoverTimeout);
				hoverTimeout = setTimeout(() => {
					toggleMenuContents(event.target.getAttribute("data-option"));
				}, 200);
			});

			option.addEventListener("mouseleave", () => {
				clearTimeout(hoverTimeout);
			});
		});

		const megaMenuLeftFirstOption =
			liContainer.querySelector(".mega-menu-left>*");
		const firstOptionType = megaMenuLeftFirstOption.dataset.option;

		liContainer.addEventListener("mouseover", () => {
			if (firstHover) {
				const associatedContent = liContainer.querySelector(
					`.mega-menu-right-content[data-content="${firstOptionType}"]`,
				);
				if (associatedContent) {
					menuContents.forEach((content) => {
						content.style.display = "none";
					});
					associatedContent.style.display = "block";
					firstHover = false;
					lastVisibleContent = associatedContent;
				}
			} else if (lastVisibleContent) {
				menuContents.forEach((content) => {
					content.style.display = "none";
				});
				lastVisibleContent.style.display = "block";
			}
		});

		liContainer.addEventListener("mouseover", () => {
			if (firstHover) {
				const associatedContent = liContainer.querySelector(
					'.mega-menu-right-content[data-content="adult"]',
				);
				if (associatedContent) {
					menuContents.forEach((content) => {
						content.style.display = "none";
					});
					associatedContent.style.display = "block";
					firstHover = false;
					lastVisibleContent = associatedContent;
				}
			} else if (lastVisibleContent) {
				menuContents.forEach((content) => {
					content.style.display = "none";
				});
				lastVisibleContent.style.display = "block";
			}
		});

		function toggleMenuContents(optionIndex) {
			const contentToShow = liContainer.querySelector(
				`.mega-menu-right-content[data-content="${optionIndex}"]`,
			);
			if (optionIndex !== "standard") {
				hideMenuContents();
				contentToShow.style.display = "block";
				contentToShow.style.visibility = "visible";
				lastVisibleContent = contentToShow;
			} else if (lastVisibleContent) {
				hideMenuContents(lastVisibleContent);
				lastVisibleContent.style.display = "block";
				contentToShow.style.visibility = "visible";
			}
		}

		function hideMenuContents(excludedContent) {
			menuContents.forEach((content) => {
				if (content !== excludedContent) {
					content.style.display = "none";
					content.style.visibility = "hidden";
				}
			});
		}
	});
}

function setMegaMenuPosition() {
	const megaMenuContents = document.querySelectorAll(".mega-menu-content");
	const megaMenuWrapper = document.querySelector(".header__inline-menu");

	if (megaMenuWrapper) {
		megaMenuContents.forEach((megaMenuContent) => {
			const liContainer = megaMenuContent.closest(
				".li-container.mega-menu-container.mega-menu-wrapper",
			);
			const rect = liContainer.getBoundingClientRect();
			const leftValue = rect.left;

			megaMenuContent.style.visibility = "hidden";
			megaMenuContent.style.left = `${-leftValue}px`;
			megaMenuContent.style.width = `100vw`;
			megaMenuContent.style.visibility = "visible";
		});
	}
}

function setupEventListeners() {
	const parentLis = document.querySelectorAll(".mega-menu-wrapper > li");

	if (!parentLis.length) return;

	parentLis.forEach((parentLi) => {
		parentLi.addEventListener("mouseenter", updateMegaMenuPosition);
		parentLi.addEventListener("mouseleave", updateMegaMenuPosition);
	});

	window.addEventListener("resize", setMegaMenuPosition);
}

function updateMegaMenuPosition() {
	setTimeout(() => {
		setMegaMenuPosition();
	}, 100);
}

// MEGA MENU DESKTOP STYLING
document
	.querySelectorAll(".mega-menu-option:not(.standard-option):not(.mobile)")
	.forEach((option) => {
		let chevronTimeout;

		option.addEventListener("mouseover", (e) => {
			const target = e.target;
			const contentKey = target.dataset.option;

			clearTimeout(chevronTimeout);
			chevronTimeout = setTimeout(() => {
				document
					.querySelectorAll(".mega-menu-option:not(.mobile)")
					.forEach((otherOption) => {
						otherOption.classList.remove("show-chevron");
					});

				target.classList.add("show-chevron");

				document
					.querySelectorAll(".mega-menu-right-content")
					.forEach((content) => {
						if (content.dataset.content === contentKey) {
							content.style.display = "block";
						} else {
							content.style.display = "none";
						}
					});
			}, 200);
		});

		option.addEventListener("mouseleave", () => {
			clearTimeout(chevronTimeout);
		});
	});

document.addEventListener("DOMContentLoaded", function() {
    const megaMenuContent = document.querySelector(".mega-menu-content");

    if (megaMenuContent) {
        // Only add the event listener if .mega-menu-content exists
        megaMenuContent.addEventListener("mouseleave", () => {
            document.querySelectorAll(".mega-menu-right-content").forEach((content) => {
                content.style.display = "none";
            });

            document.querySelectorAll(".mega-menu-option:not(.standard-option):not(.mobile)").forEach((option) => {
                option.classList.remove("show-chevron");
            });
        });
    } else {
        console.warn("Element with class '.mega-menu-content' not found. Skipping event listener setup.");
    }
});

// DROPDOWN MOBILE MENU FUNCTIONALITY
const drawer = document.getElementById("menu-drawer");
const contentContainer = document.querySelector(".menu-drawer__content");
const hamburgerButton = document.querySelector(".hamburger");
const closeButton = document.querySelector(".close");
const backButton = document.createElement("button");
const storedDropdownMenus = {};
backButton.innerText = "Back";
backButton.classList.add("back-button");
backButton.style.display = "none";
contentContainer.appendChild(backButton);
const menuOptions = document.querySelectorAll(".dropdown-header-mobile");
menuOptions.forEach((menuOption, index) => {
	menuOption.addEventListener("click", (event) => {
		event.preventDefault();
		const dropdownMenu = menuOption.nextElementSibling;
		const mainMenu = document.querySelector(".menu-drawer__navigation");
		const spanText = menuOption.querySelector("span").innerText;
		let lowercaseSpanText = spanText.toLowerCase();
		let capitalizedFirstLetterSpanText =
			lowercaseSpanText.charAt(0).toUpperCase() + lowercaseSpanText.slice(1);
		backButton.innerHTML = "";
		backButton.insertAdjacentHTML(
			"beforeend",
			`<svg width="8" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:10px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8839 1.11612C13.372 1.60427 13.372 2.39573 12.8839 2.88388L3.76777 12L12.8839 21.1161C13.372 21.6043 13.372 22.3957 12.8839 22.8839C12.3957 23.372 11.6043 23.372 11.1161 22.8839L1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12C0.75 11.6685 0.881696 11.3505 1.11612 11.1161L11.1161 1.11612C11.6043 0.627961 12.3957 0.627961 12.8839 1.11612Z" fill="#FF0000"/></svg>${capitalizedFirstLetterSpanText}`,
		);
		if (dropdownMenu) {
			storedDropdownMenus[spanText] = dropdownMenu;
		}
		mainMenu.style.display = "none";
		contentContainer.appendChild(storedDropdownMenus[spanText]);
		storedDropdownMenus[spanText].style.display = "block";
		backButton.style.display = "flex";
	});
});
hamburgerButton.addEventListener("click", () => {
	drawer.classList.add("open");
});
backButton.addEventListener("click", () => {
	const mainMenu = document.querySelector(".menu-drawer__navigation");
	mainMenu.style.display = "block";
	backButton.style.display = "none";
	Object.values(storedDropdownMenus).forEach((dropdownMenu) => {
		dropdownMenu.style.display = "none";
		const originalParent = document.querySelector(".dropdown-mobile");
		originalParent.appendChild(dropdownMenu);
	});
});

// MEGA MENU MOBILE FUNCTIONALITY BELOW
document.addEventListener("DOMContentLoaded", function () {
	const menuDrawer = document.getElementById("menu-drawer");

	const megaMenuContainers = document.querySelectorAll(
		".mega-menu-container-mobile",
	);
	megaMenuContainers.forEach((megaMenuContainer) => {
		const firstStandardMobile = megaMenuContainer.querySelector(
			".standard-option.mobile",
		);
		if (firstStandardMobile) {
			firstStandardMobile.style.borderTop = "1px lightgrey solid";
			firstStandardMobile.style.paddingTop = "40px";
			firstStandardMobile.style.marginTop = "20px";
		}
		const megaMenuToggle = megaMenuContainer.querySelector(".mega-menu-toggle");

		const megaMenuOptions = megaMenuContainer.querySelectorAll(
			".mega-menu-option.mobile",
		);
		const megaMenuRightContents = megaMenuContainer.querySelectorAll(
			".mega-menu-right-content",
		);
		const megaMenuTitleMobile = megaMenuContainer.querySelector(
			".mega-menu-title-mobile",
		);
		const megaMenuLeftMobile = megaMenuContainer.querySelector(
			".mega-menu-left-mobile",
		);
		const megaMenuContentMobile = megaMenuContainer.querySelector(
			".mega-menu-content-mobile",
		);

		function resetDrawerState() {
			const level2BackButton = document.querySelector(".level-2-back");
			const level3BackButton = document.querySelector(".level-3-back");
			level2BackButton.style.display = "none";
			level3BackButton.style.display = "none";
		}

		megaMenuLeftMobile.style.display = "none";

		function hideElements(elements, origin = null) {
			elements.forEach((element) => {
				element.style.display = "none";
			});
		}

		function showElement(element) {
			console.log("showing", element);
			element.style.display = "flex";
			console.log("after change", element);
		}

		megaMenuToggle.addEventListener("click", (e) => {
			e.stopPropagation();
			
			hideElements(megaMenuRightContents, "megaMenuToggle1");
			hideElements([megaMenuTitleMobile, megaMenuToggle], "megaMenuToggle2");
			showElement(megaMenuContentMobile);
			showElement(megaMenuLeftMobile);
		});

		let level3BackButtonText = "";

		megaMenuOptions.forEach((option) => {
			option.addEventListener("click", function (e) {
				if (
					this.classList.contains("mobile") &&
					this.classList.contains("standard-option")
				) {
					return;
				}
				e.stopPropagation();
				const selectedOption = this.dataset.option;
				const currentLevel = parseInt(
					megaMenuContainer.querySelector(".level-2-back").style.display ===
						"flex"
						? 2
						: 3,
				);
				if (currentLevel === 2) {
					level3BackButtonText = this.innerText;
					showLevel(3, selectedOption);
				}

				const backButton = document.querySelector(".backButton");
				backButton.innerText = this.innerText;
			});
		});

		const leftMenuTitle = megaMenuContainer.querySelector(
			"mobile-children-left-menu-title",
		);
		const rightMenuTitle = megaMenuContainer.querySelector(
			"mobile-children-right-menu-title",
		);
		const leftMenuBody = megaMenuContainer.querySelector(
			"mobile-children-left-menu-body",
		);
		const rightMenuBody = megaMenuContainer.querySelector(
			"mobile-children-right-menu-body",
		);

		if (leftMenuTitle && leftMenuBody) {
			leftMenuTitle.addEventListener("click", () => {
				if (rightMenuBody) hideElements([rightMenuBody], "leftMenuTitle");
				toggleElement(leftMenuBody);
			});
		}

		if (rightMenuTitle && rightMenuBody) {
			rightMenuTitle.addEventListener("click", () => {
				if (leftMenuBody) hideElements([leftMenuBody], "rightMenuTitle");
				toggleElement(rightMenuBody);
			});
		}
		function toggleElement(element) {
			if (element.style.display === "none" || element.style.display === "") {
				element.style.display = "flex";
			} else {
				element.style.display = "none";
			}
		}

		megaMenuContainer
			.querySelectorAll(".mega-menu-category-list-title")
			.forEach((title) => {
				title.addEventListener("click", () => {
					const menuItems = title.nextElementSibling;
					if (menuItems.style.display === "none") {
						menuItems.style.display = "block";
					} else {
						menuItems.style.display = "none";
					}
				});
			});

		megaMenuContainer
			.querySelectorAll(".megamenu-collections-mobile-header")
			.forEach((header) => {
				header.addEventListener("click", () => {
					const cardMenu = header.nextElementSibling;
					if (cardMenu.style.display === "none") {
						cardMenu.style.display = "flex";
					} else {
						cardMenu.style.display = "none";
					}
				});
			});

		function resetMenuState() {
			showLevel(1);
		}

		document.addEventListener("click", function (event) {
			if (
				!event.target.closest(".menu-drawer") &&
				!event.target.closest(".menu-drawer__toggle") &&
				!event.target.closest(".mega-menu-content")
			) {
				menuDrawer.classList.remove("menu-drawer--open");
				showElement(megaMenuTitleMobile);
				showElement(megaMenuToggle);
				hideElements(menuDrawer.querySelectorAll(".mega-menu"), "document 1");

				if (!event.target.closest(".mega-menu-wrapper")) {
					hideElements(megaMenuRightContents, "document2");
					hideElements([megaMenuLeftMobile], "document3");
					resetMenuState();
				}
			}
		});

		let originalBackButtonText = "";

		megaMenuTitleMobile.addEventListener("click", function () {
			showLevel(2);
			const backButton = megaMenuContainer.querySelector(".backButton");
			const chevronSpan = backButton.querySelector("span");
			backButton.innerHTML = "";
			backButton.appendChild(chevronSpan);
			originalBackButtonText = this.innerText;
			backButton.appendChild(document.createTextNode(originalBackButtonText));
		});

		const backButtons = document.querySelectorAll(".backButton");
		const chevronSpan = document.createElement("span");
		chevronSpan.innerHTML =
			'<svg width="8" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:10px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8839 1.11612C13.372 1.60427 13.372 2.39573 12.8839 2.88388L3.76777 12L12.8839 21.1161C13.372 21.6043 13.372 22.3957 12.8839 22.8839C12.3957 23.372 11.6043 23.372 11.1161 22.8839L1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12C0.75 11.6685 0.881696 11.3505 1.11612 11.1161L11.1161 1.11612C11.6043 0.627961 12.3957 0.627961 12.8839 1.11612Z" fill="#FF0000"/></svg>';
		chevronSpan.style.marginRight = "12px";

		function createChevronSpan() {
			const chevronSpan = document.createElement("span");
			chevronSpan.innerHTML =
				'<svg width="8" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8839 1.11612C13.372 1.60427 13.372 2.39573 12.8839 2.88388L3.76777 12L12.8839 21.1161C13.372 21.6043 13.372 22.3957 12.8839 22.8839C12.3957 23.372 11.6043 23.372 11.1161 22.8839L1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12C0.75 11.6685 0.881696 11.3505 1.11612 11.1161L11.1161 1.11612C11.6043 0.627961 12.3957 0.627961 12.8839 1.11612Z" fill="#FF0000"/></svg>';
			chevronSpan.style.marginRight = "12px";
			return chevronSpan;
		}

		function updateBackButtonText(backButton, text) {
			const chevronSpan = createChevronSpan();
			backButton.innerHTML = "";
			backButton.appendChild(chevronSpan);
			backButton.appendChild(document.createTextNode(text));
		}

		backButtons.forEach(function (backButton) {
			backButton.addEventListener("click", function () {
				const currentLevel = parseInt(this.parentElement.dataset.level);
				if (currentLevel === 3) {
					const backButton = document.querySelector(".backButton");
					updateBackButtonText(backButton, originalBackButtonText);
				}
				showLevel(currentLevel - 1);
			});

			if (backButton.parentElement.dataset.level === "2") {
				const chevronSpan = createChevronSpan();
				backButton.innerHTML = "";
				backButton.style.display = "flex";
				backButton.appendChild(chevronSpan);
				backButton.appendChild(document.createTextNode(backButton.innerText));
			}
		});

		function showLevel(level, selectedOption, clickedElement) {
			const megaMenuTitleMobile = megaMenuContainer.querySelector(
				".mega-menu-title-mobile",
			);
			const megaMenuOptions = megaMenuContainer.querySelector(
				".mega-menu-left-mobile",
			);
			const megaMenuRightContents = megaMenuContainer.querySelectorAll(
				".mega-menu-right-content",
			);
			const menuDrawerAccount = document.querySelector(
				".menu-drawer-login-container",
			);
			const wishListContainer = document.querySelector(
				".wishlist-login-container",
			);
			const liContainers = document.querySelectorAll(".header-mobile-drawer");
			const level2BackButton = megaMenuContainer.querySelector(".level-2-back");
			const level3BackButton = megaMenuContainer.querySelector(".level-3-back");

			if (level === 1) {
				megaMenuContainers.forEach((megaMenuContainer) => {
					megaMenuContainer.style.display = "block";
				});
				megaMenuTitleMobile.style.display = "flex";
				megaMenuOptions.style.display = "none";
				hideElements(megaMenuRightContents, "showLevel1");
				level2BackButton.style.display = "none";
				level3BackButton.style.display = "none";
				wishListContainer.style.display = "flex";
				if (menuDrawerAccount) {
					menuDrawerAccount.classList.remove("menu-drawer__account--hidden");
				}
				liContainers.forEach((container) => {
					if (container.classList.contains("dropdown-header-mobile")) {
						container.style.display = "block";
					} else {
						container.style.display = "flex";
					}
				});
			} else if (level === 2) {
				wishListContainer.style.display = "none";
				megaMenuTitleMobile.style.display = "none";
				megaMenuOptions.style.display = "block";
				hideElements(megaMenuRightContents, "showLevel2");
				level2BackButton.style.display = "flex";
				level3BackButton.style.display = "none";
				if (menuDrawerAccount) {
					menuDrawerAccount.classList.add("menu-drawer__account--hidden");
				}
				hideElements(liContainers, "showLevel2 2");
			} else if (level === 3) {
				wishListContainer.style.display = "none";
				megaMenuTitleMobile.style.display = "none";
				megaMenuOptions.style.display = "none";
				if (menuDrawerAccount) {
					menuDrawerAccount.classList.add("menu-drawer__account--hidden");
				}
				hideElements(liContainers, "showLevel3 1");
				megaMenuRightContents.forEach((content) => {
					if (content.dataset.content === selectedOption) {
						content.style.display = "block";
					} else {
						content.style.display = "none";
					}
				});
				level2BackButton.style.display = "none";
				level3BackButton.style.display = "flex";
				updateBackButtonText(level3BackButton, level3BackButtonText);
			}
		}
		showLevel(1);
	});
});

// ANIMATION OF THE CLOSING OF THE MENU DRAWER
function closeMenuDrawerWithAnimation() {
	const menuDrawer = document.querySelector("#menu-drawer");
	const menuDrawerContainer = document.querySelector(".menu-drawer-container");
	const summary = document.querySelector("summary");
	summary.setAttribute("aria-expanded", "false");

	menuDrawer.animate(
		[
			{
				transform: "translateX(0)",
			},
			{
				transform: "translateX(-100%)",
			},
		],
		{
			duration: 300,
			easing: "ease",
		},
	).onfinish = () => {
		menuDrawerContainer.removeAttribute("open");
		menuDrawer.classList.remove("menu-opening");

		const submenuOpenElements =
			menuDrawerContainer.querySelectorAll(".submenu-open");
		submenuOpenElements.forEach(function (submenu) {
			submenu.classList.remove("submenu-open");
		});

		const bodyClassList = document.body.classList;
		const overflowHiddenClass = Array.from(bodyClassList).find((className) =>
			className.startsWith("overflow-hidden-"),
		);
		if (overflowHiddenClass) {
			bodyClassList.remove(overflowHiddenClass);
		}
	};
}

// ADDITION OF CLOSING FUNCTIONALITY TO 'X' IN MENU DRAWER
document.addEventListener("DOMContentLoaded", function () {
	const closeButtons = document.querySelectorAll(".menu-drawer-close-wrapper");

	closeButtons.forEach((button) => {
		button.addEventListener("click", closeMenuDrawerWithAnimation);
	});
});

//ACCOUNT ICON BEHAVIOUR WHEN USER LOGGED IN
document.addEventListener("DOMContentLoaded", function () {
	const dropdownHeaderAccount = document.querySelector(
		".dropdown-header-account",
	);
	const dropdownMenuAccount = document.querySelector(".dropdown-menu-account");

	if (dropdownMenuAccount) {
		const showDropdownMenu = () => {
			dropdownMenuAccount.style.opacity = "1";
			dropdownMenuAccount.style.visibility = "visible";
			dropdownMenuAccount.style.transform = "translate(0px, 0px)";
		};

		const hideDropdownMenu = () => {
			dropdownMenuAccount.style.opacity = "0";
			dropdownMenuAccount.style.visibility = "hidden";
			dropdownMenuAccount.style.transform = "translate(0px, 20px)";
		};

		dropdownHeaderAccount.addEventListener("mouseenter", showDropdownMenu);
		dropdownHeaderAccount.addEventListener("mouseleave", hideDropdownMenu);
		dropdownMenuAccount.addEventListener("mouseenter", showDropdownMenu);
		dropdownMenuAccount.addEventListener("mouseleave", hideDropdownMenu);
	}
});
